module.exports = __webpack_public_path__ + "static/img/gz_09.b6c6327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_09.jpg
// module id = eBVh
// module chunks = 0